import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subDescription',
  pure: true
})
export class SubDescriptionPipe implements PipeTransform {
  transform(packId: number, currencyMeta: any): string {
    if (!currencyMeta?.Packs) return '';
    
    const pack = currencyMeta.Packs.find((p: any) => p.Id === packId);
    return pack?.Description || '';
  }
}
